import React, { ReactNode, useState } from "react";

import Box from "@mui/material/Box";
import Button from "components/Button";
import Typography from "@mui/material/Typography";

interface BankItemProps {
  title: string;
  icon: ReactNode;
  description?: string;
  onClick: () => void | Promise<void>;
}

const BankItem: React.FC<BankItemProps> = ({
  title,
  icon,
  description,
  onClick,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 2.5,
        borderRadius: 3,
        border: "1px solid #E5E5E5",
        width: "100%",
      }}
    >
      {icon}
      <Box sx={{ ml: 2, mr: 2 }}>
        <Typography variant="h5">{title}</Typography>
        {description && <Typography color="grey700">{description}</Typography>}
      </Box>
      <Button
        sx={{ ml: "auto" }}
        onClick={handleClick}
        withBorder
        loading={isLoading}
      >
        Підключити
      </Button>
    </Box>
  );
};

export default BankItem;
